module.exports = __webpack_public_path__ + "img/avatar_real_9.16e12418.jpg";